// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| OVERRIDES - DIALOG / MENU / POPOVER ||============================== //

export default function Dialog(theme) {
  const v = theme.vars.palette;
  return {
    MuiDialog: {
      styleOverrides: {
        paper: { borderRadius: 10, boxShadow: '0 20px 48px rgba(16,24,40,0.18)' }
      }
    },
    MuiBackdrop: {
      styleOverrides: { root: { backgroundColor: withAlpha(v.grey[900], 0.45) } }
    },
    MuiDialogTitle: {
      styleOverrides: { root: { fontSize: '1.0625rem', fontWeight: 600, padding: '18px 24px 12px', color: v.grey[900] } }
    },
    MuiDialogContent: { styleOverrides: { root: { padding: '8px 24px 16px' } } },
    MuiDialogActions: { styleOverrides: { root: { padding: '12px 24px 20px', gap: 8 } } },
    MuiMenu: {
      styleOverrides: { paper: { borderRadius: 10, border: `1px solid ${v.grey[200]}`, boxShadow: '0 8px 24px rgba(16,24,40,0.12)' } }
    },
    MuiMenuItem: {
      styleOverrides: { root: { fontSize: '0.875rem', borderRadius: 6, margin: '2px 6px', minHeight: 36 } }
    },
    MuiPopover: { styleOverrides: { paper: { borderRadius: 10 } } }
  };
}
